import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const createSegmentPriceBook = createAsyncThunk("createSegmentPriceBook", async ({ values, channel_uuid }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`price-book/segment?channel_uuid=${channel_uuid}`, values);

		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const SegmentPriceBookCreateSlice = createSlice({
	name: "SegmentPriceBookCreateSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetCreateSegmentPriceBookState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(createSegmentPriceBook.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(createSegmentPriceBook.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(createSegmentPriceBook.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetCreateSegmentPriceBookState } = SegmentPriceBookCreateSlice.actions;

export default SegmentPriceBookCreateSlice.reducer;
